var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.333 9.167h-2.5v-2.5a.833.833 0 10-1.667 0V10c0 .46.374.833.834.833h3.333a.833.833 0 100-1.666zM10 16.667A6.674 6.674 0 013.333 10 6.674 6.674 0 0110 3.333 6.674 6.674 0 0116.666 10 6.674 6.674 0 0110 16.667zm0-15c-4.595 0-8.333 3.738-8.333 8.333 0 4.595 3.738 8.333 8.333 8.333 4.595 0 8.333-3.738 8.333-8.333 0-4.595-3.738-8.333-8.333-8.333z",
    fill: "current"
  })));
}
export default SvgClock;